import { Doughnut } from 'react-chartjs-2';
import { useTheme } from 'styled-components';
import S from './DoghnutChartWidgetStyles';
import { ThemeType } from '../../../theme/themeType';
import InfoCard from '../../InfoCard/InfoCard';
import { InfoCardProps } from '../../InfoCard/InfoCardProps';
import GlobalSpinner from '../GlobalSpinner/GlobalSpinner';

const CUTOUT_RADIUS = 22;
const BORDER_WIDTH = 4;

type Props = {
  data: {
    cards: Record<string, InfoCardProps>;
    title: string;
  }
  percentage?: boolean,
  type?: 'single' | 'double' | 'triple' | 'quad',
  loading?: boolean;
};

function DoghnutChartWidget({
  data, type, percentage, loading = false,
}: Props): JSX.Element {
  const theme = useTheme() as ThemeType;
  const values = Object.values(data.cards).map((card) => card.count);
  const total = values.reduce((sum: number, currentValue: number | undefined) => sum + (currentValue || 0), 0);

  const chartConfig = {
    datasets: [
      {
        data: values,
        backgroundColor: Object.values(data.cards).map((card) => card.color),
        borderColor: theme.colors.widget_background,
        borderWidth: BORDER_WIDTH,
        cutout: CUTOUT_RADIUS,
      },
    ],
  };

  const options = {
    responsive: true,
    tooltips: {
      mode: 'label',
    },
    plugins: {
      tooltip: {
        enabled: true,
        callbacks: {
          label: (value: any) => {
            if (percentage && !!value.raw) {
              return `${Math.round((value.raw * 10000) / total) / 100}%`;
            }
            return value.raw;
          },
        },
      },
    },
  };

  if (loading) {
    return (<GlobalSpinner />);
  }

  return (
    <S.Wrapper>
      <div className="widget-name">{data.title}</div>
      {total === 0 ? (
        <div className="no-data">No data for selected period</div>
      ) : (
        <div className="widget-container">
          <div className="chart-container">
            <Doughnut height={200} width={200} data={chartConfig} options={options} />
          </div>
          <div className="info-cards">
            {Object.values(data.cards).map((item: InfoCardProps) => (
              <InfoCard key={item.label} data={item} type={type} />
            ))}
          </div>
        </div>
      )}
    </S.Wrapper>
  );
}

export default DoghnutChartWidget;
